__turbopack_context__.v({
  "animatedWrapper": "styles-module__AH2IEW__animatedWrapper",
  "container": "styles-module__AH2IEW__container",
  "listItem": "styles-module__AH2IEW__listItem",
  "loaderWrapper": "styles-module__AH2IEW__loaderWrapper",
  "productGrid": "styles-module__AH2IEW__productGrid",
  "wiggle": "styles-module__AH2IEW__wiggle",
});
